import React from 'react';
import useSearchParams from '../SearchFilters.hooks';
import { parse } from '../../../util/urlHelpers';
import { FormattedMessage } from 'react-intl';

import css from './NumberOfEnginesFilter.module.css';

const SEARCH_PARAM = 'numberOfEngines';

const NumberOfEngines = () => {
  const { handleValueChanged, handleResetFilter, search } = useSearchParams({
    searchParamName: SEARCH_PARAM,
  });
  const currentValue = `${parse(search)[SEARCH_PARAM]}`;

  const handleChange = value => {
    if (value === currentValue) {
      handleResetFilter();
    } else {
      handleValueChanged(value);
    }
  };

  return (
    <div className={css.root}>
      <label className={css.option}>
        <input
          type="radio"
          name="numberOfEngines"
          value="single"
          checked={currentValue === 'single'}
          onChange={() => handleChange('single')}
          className={css.input}
        />
        <span className={css.square} />
        <FormattedMessage id="SearchFilters.singleEngine" />
      </label>

      <label className={css.option}>
        <input
          type="radio"
          name="numberOfEngines"
          value="multi"
          checked={currentValue === 'multi'}
          onChange={() => handleChange('multi')}
          className={css.input}
        />
        <span className={css.square} />
        <FormattedMessage id="SearchFilters.multiEngine" />
      </label>
    </div>
  );
};

export default NumberOfEngines;
